var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15825 3.71223L6.7556 2.80625C6.49232 2.21388 6.36068 1.91768 6.1638 1.69101C5.91707 1.40694 5.59547 1.19794 5.23567 1.08785C4.94858 1 4.62446 1 3.97621 1C3.02791 1 2.55375 1 2.15573 1.18229C1.68687 1.39702 1.26343 1.86328 1.09473 2.3506C0.951511 2.76429 0.992531 3.18943 1.07458 4.0397C1.94791 13.0902 6.90981 18.0521 15.9603 18.9254C16.8106 19.0075 17.2357 19.0485 17.6494 18.9053C18.1367 18.7366 18.603 18.3131 18.8177 17.8443C19 17.4462 19 16.9721 19 16.0238C19 15.3755 19 15.0514 18.9122 14.7643C18.8021 14.4045 18.5931 14.0829 18.309 13.8362C18.0823 13.6393 17.7861 13.5077 17.1937 13.2444L16.2878 12.8417C15.6462 12.5566 15.3255 12.4141 14.9995 12.3831C14.6876 12.3534 14.3731 12.3972 14.0811 12.5109C13.776 12.6297 13.5063 12.8544 12.967 13.3038C12.4301 13.7512 12.1617 13.9749 11.8337 14.0947C11.543 14.2009 11.1586 14.2403 10.8523 14.1951C10.5069 14.1442 10.2423 14.0029 9.7133 13.7201C8.0672 12.8405 7.15953 11.9328 6.27986 10.2867C5.99714 9.7577 5.85578 9.4931 5.80487 9.1477C5.75974 8.8414 5.79908 8.457 5.9053 8.1663C6.02512 7.83828 6.24881 7.56986 6.69619 7.033C7.14562 6.49368 7.37034 6.22402 7.48915 5.91891C7.60285 5.62694 7.64661 5.3124 7.61694 5.00048C7.58594 4.67452 7.44338 4.35376 7.15825 3.71223Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.2dc3e301a7b0b30b95368a1985a4d725.svg";
export { ForwardRef as ReactComponent };